module.exports = __webpack_public_path__ + "img/home_logo1.36779e4a.png";